<template>
  <el-skeleton :loading="isLoadingPlaces" animated class="persons-grid-cont">
    <template slot="template">
      <div class="persons-grid">
        <el-skeleton-item class="persons-loading" animated v-for="n in 8" :key="n" />
      </div>
    </template>
    <template>
      <div v-if="getAvailablePlaces" class="persons-grid">
        <el-button class="persons-button" v-for="n in visiblePlaces" :key="n" @click="handleNbCouvert(n)">
          {{ n }}
        </el-button>
        <el-button v-if="showSeeMore" class="persons-button see-more-button" @click="seeMore">
          Voir plus
        </el-button>
      </div>
    </template>
  </el-skeleton>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PersonsSelection',
  data() {
    return {
      maxVisible: 20
    }
  },
  computed: {
    ...mapGetters({
      getAvailablePlaces: 'forkBooking/getAvailablePlaces',
      isLoadingPlaces: 'forkBooking/isLoadingPlaces'
    }),
    visiblePlaces() {
      return this.getAvailablePlaces.slice(0, this.maxVisible)
    },
    showSeeMore() {
      return this.getAvailablePlaces.length > this.maxVisible
    }
  },
  methods: {
    ...mapActions({
      setNbCouvert: 'forkBooking/setNbCouvert',
      setCurrentStep: 'forkBooking/setCurrentStep'
    }),
    handleNbCouvert(nbCouvert) {
      this.setCurrentStep(2)
      this.setNbCouvert(nbCouvert)
    },
    seeMore() {
      this.maxVisible = this.getAvailablePlaces.length
    }
  }
}
</script>

<style lang="scss">
.persons-grid-cont {
  height: calc(100% - 117px);
  overflow-y: auto;
}

.persons-loading {
  height: 40px;
  border-radius: 50px;
}

.persons-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 16px;
  gap: 8px;

  .persons-button {
    margin: 0;
    border-radius: 50px;
    padding: 0;
    height: 40px;
  }

  .see-more-button {
    grid-column: span 4;
  }
}
</style>